module.exports = __webpack_public_path__ + "static/img/blogs-leftside.ed0ce32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/blogs-leftside.jpg
// module id = dNFu
// module chunks = 36